__turbopack_context__.v({
  "list": "ExtraList-module-scss-module__NeL_Aa__list",
  "section": "ExtraList-module-scss-module__NeL_Aa__section",
  "subtitle": "ExtraList-module-scss-module__NeL_Aa__subtitle",
  "title": "ExtraList-module-scss-module__NeL_Aa__title",
});
